module.exports = __webpack_public_path__ + "static/media/calendar-6.ca42874a.png";